import Accordion from 'components/base/accordion';
import { OrderDetailsType } from 'models/order.model';
import React, { FC } from 'react';

type MealAccordionType = {
  user_name: string;
  meals: OrderDetailsType[];
};

type ItemType = {
  isGroupOrder: boolean;
  fullName: string;
  orderDetails: OrderDetailsType[];
  subGroupOrder: MealAccordionType[];
  open: string[];
  // setOpen: (item: string[]) => void;
  handleOpenAccordion: (item: string) => void;
};

const OrderDetailsBody: FC<ItemType> = ({
  isGroupOrder,
  fullName,
  orderDetails,
  open,
  handleOpenAccordion,
  subGroupOrder
}) => {
  return (
    <div className='order-body'>
      <div>
        {isGroupOrder && (
          <span className='pl-4 text-xs'>
            {1 + '.'} Host - {fullName}
          </span>
        )}
      </div>

      {orderDetails.map((item, idx) => {
        const index = String(idx);
        return (
          <div
            key={idx}
            className={`${orderDetails.length - 1 === idx ? '' : ' border-b border-gray-border '}`}>
            <Accordion
              open={open.includes(index)}
              handleOpenAccordion={() => handleOpenAccordion(index)}
              list={item}
            />
          </div>
        );
      })}

      {subGroupOrder &&
        subGroupOrder.map((item, idx) => (
          <>
            <span className='pl-4 text-sm'>
              {idx + 2 + '.'} {item?.user_name}
            </span>
            {item?.meals.map((itm, i) => {
              const index = String(i + item?.user_name);
              return (
                <div
                  key={index}
                  className={`mx-6 ${
                    itm?.meal.length - 1 === idx ? '' : 'border-b border-gray-border '
                  }`}>
                  <Accordion
                    open={open.includes(index)}
                    handleOpenAccordion={() => handleOpenAccordion(index)}
                    list={itm}
                  />
                </div>
              );
            })}
          </>
        ))}
    </div>
  );
};

export default OrderDetailsBody;
